import React, { useEffect, useState } from 'react';
import ReactToPrint from 'react-to-print';
import { TextField } from '@mui/material';
import companylogo from "../../assets/company.png"

const AllVendorReports = () => {
    const componentRef = React.createRef();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [data, setData] = useState([]);
    const [vendorData, setvendorData] = useState([]);


    useEffect(() => {
        const getVendors = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_BASE_URL}/vendors/all_vendors`);
                if (res.ok) {
                    const data = await res.json();
                    const formattedData = data.vendor.map((vendor) => ({
                        id: vendor.id,
                        companyName: vendor.vendortitle
                    }));
                    setvendorData(formattedData);
                } else {
                    console.error(`Error: ${res.status} - ${res.statusText}`);
                }
            } catch (error) {
                console.error(error);
            }
        };
        const fetchvendorData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/vendors/all_accounts`);
                const responseData = await response.json();
                if (responseData) {
                    setData(responseData.accounts);
                }
            } catch (error) {
                console.log(error.message);
            }
        };
        fetchvendorData();
        getVendors();
    }, []);

    const filteredData = data.filter((transaction) => {
        const transactionDate = new Date(transaction.date);
        return (
            (!startDate || transactionDate >= new Date(startDate)) &&
            (!endDate || transactionDate <= new Date(endDate))
        );
    });

    const vendors = {};

    filteredData?.forEach((transaction) => {
        const { vendorid, Balance, credit, debit, date, docid, description } = transaction;

        if (!vendors[vendorid]) {
            vendors[vendorid] = {
                vendorid,
                totalDebit: 0,
                totalCredit: 0,
                closingBalance: parseFloat(Balance),
            };
        }

        vendors[vendorid].totalDebit += parseFloat(debit);
        vendors[vendorid].totalCredit += parseFloat(credit);
        vendors[vendorid].closingBalance = vendors[vendorid].totalCredit - vendors[vendorid].totalDebit;
    });

    const allvendors = Object.values(vendors);

    const totaldebit = allvendors.reduce((sum, vendor) => sum + vendor.totalDebit, 0)
    const totalcredit = allvendors.reduce((sum, vendor) => sum + vendor.totalCredit, 0)
    const totalbalance = totaldebit - totalcredit

    return (
        <div className='w-full'>
            <div className='mb-5 flex flex-row justify-center items-center gap-2'>
                <TextField
                    type='date'
                    value={startDate || ''}
                    onChange={(e) => setStartDate(e.target.value)}
                />
                <TextField
                    type='date'
                    value={endDate || ''}
                    onChange={(e) => setEndDate(e.target.value)}
                />
            </div>
            <div className="invoice__preview w-full bg-white p-5 rounded-2xl border-4 border-blue-200  ">
                <ReactToPrint
                    trigger={() => (
                        <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                            Print / Download
                        </button>
                    )}
                    content={() => componentRef.current}
                />
                <div ref={componentRef} className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative">
                    <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                        <div>

                            <img  src={companylogo} alt="logo" />
                        </div>
                    </div>
                    <article className=" py-2 text-center text-base text-black border-t border-b border-black uppercase w-full font-bold">
                        <p>Statements of Accounts (Period)</p>
                    </article>
                    <table width="100%" className="mb-10">
                        <thead>
                            <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                                <td className="font-bold">vendor ID</td>
                                <td className="font-bold">Narration</td>
                                <td className="font-bold">Debit</td>
                                <td className="font-bold">Credit</td>
                                <td className="font-bold">Balance</td>
                            </tr>
                        </thead>
                        <tbody>
                            {allvendors.map((vendor, index) => {
                                const matchingvendorData = vendorData.find(data => data.id === parseInt(vendor.vendorid));

                                return (
                                    <tr key={vendor.vendorid}>
                                        <td>{vendor.vendorid}</td>
                                        <td>
                                            {matchingvendorData
                                                ? matchingvendorData.companyName
                                                : 'Company Name Not Found'}
                                        </td>
                                        <td>{vendor.totalDebit.toLocaleString()}</td>
                                        <td>{vendor.totalCredit.toLocaleString()}</td>
                                        <td>{(vendor.closingBalance * -1).toLocaleString()}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <tr className=" text-center bg-gray-100 p-1 py-2 mb-10 text-center text-base text-black border-t border-b border-black uppercase w-full font-semibold" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <td className=" font-semibold italic text-lg text-center  ml-4 mr-4" colSpan={2}>
                            Total Debit:
                        </td>
                        <td className=" font-bold text-md text-center" colSpan={2}>
                            {totaldebit}
                        </td>
                        <td className=" font-semibold italic text-lg text-center  ml-4 mr-4" colSpan={2}>
                            Total Credit:
                        </td>
                        <td className=" font-bold text-md text-center" colSpan={2}>
                            {totalcredit}
                        </td>
                        <td className=" font-semibold italic text-lg text-center  ml-4 mr-4" colSpan={2}>
                            Total balance:
                        </td>
                        <td className=" font-bold text-md text-center" colSpan={2}>
                            {totalbalance}
                        </td>
                    </tr>
                    <tr className=" text-center h-10 font-bold mt-2">
                        <td className=" font-bold text-lg border-t border-black text-center" colSpan={2}>
                            Accountant
                        </td>
                    </tr>
                </div>
            </div>
        </div>
    );
};

export default AllVendorReports;
